import gql from "graphql-tag";

export const LIST_ALL_POINTS = gql`
  query LIST_ALL_POINTS {
    nodeQuery(limit: 200) {
      entities {
        __typename
        entityId
        ... on NodeHeritageSite {
          title
          x: fieldMapCoordinateX
          y: fieldMapCoordinateY
        }
        ... on NodeEvent {
          title
          x: fieldMapCoordinateX
          y: fieldMapCoordinateY
          fieldEventHeritageSite {
            targetId
          }
        }
        ... on NodeSayings {
          title
          x: fieldMapCoordinateX
          y: fieldMapCoordinateY
        }
      }
    }
  }
`;
